import React from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import EditAccount from "../component/User/EditAccount/EditAccount.jsx"
const EditAccountPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
<>
<Header/>
<EditAccount/>
<Footer/>
</>
  )
}

export default EditAccountPage